// Firestore returns Timestamp objects for date fields, but the domain types
// declare them as `Date`. Normalize on every read so the rest of the app
// never has to know Timestamps exist.

function isTimestampLike(value: unknown): value is { toDate: () => Date } {
  return (
    typeof value === 'object' &&
    value !== null &&
    typeof (value as { toDate?: unknown }).toDate === 'function'
  );
}

export function fromFirestore<T>(data: unknown): T {
  if (isTimestampLike(data)) {
    return data.toDate() as unknown as T;
  }
  if (Array.isArray(data)) {
    return data.map(item => fromFirestore(item)) as unknown as T;
  }
  if (typeof data === 'object' && data !== null) {
    const out: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(data)) {
      out[key] = fromFirestore(value);
    }
    return out as T;
  }
  return data as T;
}
